module.exports = __webpack_public_path__ + "img/George Kipiani.69787d58.png";